import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=13834111"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports